import { useState, useEffect } from "react";
import axios from "axios";

/**
 * Custom hook to fetch and manage series category mappings from the iRacing API
 * @returns {Object} seriesCategoryMap - A mapping of season_name to category (e.g., "sports_car", "formula_car", "oval", etc.)
 */
export function useSeriesCategories() {
	const [seriesCategoryMap, setSeriesCategoryMap] = useState({});

	useEffect(() => {
		async function fetchSeriesCategories() {
			try {
				const response = await axios.get(
					"https://iracing6-backend.herokuapp.com/api/series-basic-info/all-seasons"
				);

				const categoryMap = {};
				if (response.data?.seasons) {
					response.data.seasons.forEach((season) => {
						if (season.season_name && season.category) {
							categoryMap[season.season_name] = season.category;
						}
					});
				}
				setSeriesCategoryMap(categoryMap);
			} catch (error) {
				console.error("Error fetching series categories:", error);
			}
		}

		fetchSeriesCategories();
	}, []);

	return seriesCategoryMap;
}
